import type { Action } from 'react-sweet-state';

import type { FieldCustomErrors } from '../../../../common/types/field-custom-errors';
import type { FormRendererState } from '../../types';

export const setFieldCustomErrors =
	(fieldCustomErrors: FieldCustomErrors): Action<FormRendererState> =>
	({ setState }) =>
		setState({ fieldCustomErrors });
